module.exports = __webpack_public_path__ + "media/images/common/login-65006364d6749190e225d001621201e4.gif";